module.exports = __webpack_public_path__ + "static/img/help1.fec57e75.png";